// ==========================================
// src/components/layout/Footer.jsx
// Professional Footer Component with Enhanced UX/UI
// ==========================================
import { motion } from 'framer-motion';
import { useState } from 'react';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const footerSections = {
    company: [
      { id: 'comp-1', name: 'About Us', href: '#about' },
      { id: 'comp-2', name: 'Our Mission', href: '#mission' },
      { id: 'comp-3', name: 'Our Team', href: '#team' },
      { id: 'comp-4', name: 'Careers', href: '#careers' },
      { id: 'comp-5', name: 'Press Kit', href: '#press' },
    ],
    solutions: [
      { id: 'sol-1', name: 'Technology', href: '#technology' },
      { id: 'sol-2', name: 'Products', href: '#product' },
      { id: 'sol-3', name: 'Case Studies', href: '#cases' },
      { id: 'sol-4', name: 'Research', href: '#research' },
      { id: 'sol-5', name: 'Partners', href: '#partners' },
    ],
    support: [
      { id: 'sup-1', name: 'Contact Us', href: '#contact' },
      { id: 'sup-2', name: 'Documentation', href: '#docs' },
      { id: 'sup-3', name: 'FAQ', href: '#faq' },
      { id: 'sup-4', name: 'Support Center', href: '#support' },
      { id: 'sup-5', name: 'Community', href: '#community' },
    ],
    legal: [
      { id: 'leg-1', name: 'Privacy Policy', href: '#privacy' },
      { id: 'leg-2', name: 'Terms of Service', href: '#terms' },
      { id: 'leg-3', name: 'Cookie Policy', href: '#cookies' },
      { id: 'leg-4', name: 'Compliance', href: '#compliance' },
    ],
    social: [
      {
        id: 'social-1',
        name: 'LinkedIn',
        href: '#',
        icon: (
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        )
      },
      {
        id: 'social-2',
        name: 'Twitter',
        href: '#',
        icon: (
          <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
        )
      },
      {
        id: 'social-3',
        name: 'GitHub',
        href: '#',
        icon: (
          <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"/>
        )
      },
      {
        id: 'social-4',
        name: 'YouTube',
        href: '#',
        icon: (
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
        )
      },
    ],
  };

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // TODO: Replace with actual API call
      await new Promise(resolve => setTimeout(resolve, 1000));

      setSubmitStatus('success');
      setEmail('');
      setTimeout(() => setSubmitStatus(null), 5000);
    } catch (error) {
      setSubmitStatus('error');
      setTimeout(() => setSubmitStatus(null), 5000);
    } finally {
      setIsSubmitting(false);
    }
  };

  const fadeInUpVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  return (
    <footer className="relative bg-gradient-to-b from-ocean-deep via-ocean-dark to-black overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-ocean-light rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-wave-yellow rounded-full blur-3xl animate-pulse delay-1000" />
      </div>

      <div className="relative container-custom">
        {/* Newsletter Section - Prominent CTA */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUpVariants}
          className="py-16 border-b border-ocean-light/10"
        >
          <div className="max-w-4xl mx-auto text-center">
            <motion.div
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="inline-block p-3 bg-ocean-light/10 rounded-full mb-6"
            >
              <svg className="w-8 h-8 text-wave-yellow" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </motion.div>

            <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Stay Updated on Ocean Innovation
            </h3>
            <p className="text-ocean-sky/80 text-lg mb-8 max-w-2xl mx-auto">
              Join our community and receive the latest insights on sustainable ocean energy, technology breakthroughs, and environmental impact.
            </p>

            <form onSubmit={handleNewsletterSubmit} className="max-w-xl mx-auto">
              <div className="flex flex-col sm:flex-row gap-3">
                <div className="flex-1 relative">
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email address"
                    className="w-full px-6 py-4 rounded-xl bg-white/5 backdrop-blur-sm border border-ocean-light/20 text-white placeholder-ocean-sky/50 focus:outline-none focus:border-wave-yellow focus:ring-2 focus:ring-wave-yellow/20 transition-all duration-300"
                    required
                    disabled={isSubmitting}
                  />
                  {submitStatus === 'success' && (
                    <motion.div
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      className="absolute -bottom-8 left-0 text-green-400 text-sm flex items-center gap-1"
                    >
                      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      Successfully subscribed!
                    </motion.div>
                  )}
                  {submitStatus === 'error' && (
                    <motion.div
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      className="absolute -bottom-8 left-0 text-red-400 text-sm"
                    >
                      Something went wrong. Please try again.
                    </motion.div>
                  )}
                </div>
                <motion.button
                  type="submit"
                  disabled={isSubmitting}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="px-8 py-4 bg-gradient-to-r from-wave-yellow to-wave-gold text-ocean-dark font-bold rounded-xl hover:shadow-lg hover:shadow-wave-yellow/30 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  {isSubmitting ? (
                    <span className="flex items-center gap-2">
                      <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                      </svg>
                      Subscribing...
                    </span>
                  ) : (
                    <span className="flex items-center gap-2">
                      Subscribe
                      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                      </svg>
                    </span>
                  )}
                </motion.button>
              </div>
            </form>

            <p className="text-ocean-sky/50 text-sm mt-6">
              We respect your privacy. Unsubscribe at any time.
            </p>
          </div>
        </motion.div>

        {/* Main Footer Content */}
        <div className="py-16">
          <div className="grid grid-cols-2 md:grid-cols-6 gap-8 lg:gap-12">
            {/* Brand Column - Spans 2 columns */}
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUpVariants}
              className="col-span-2"
            >
              {/* Logo */}
              <div className="flex items-center space-x-3 mb-6">
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-ocean-light to-ocean-blue flex items-center justify-center shadow-lg shadow-ocean-light/20">
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13 10V3L4 14h7v7l9-11h-7z"
                    />
                  </svg>
                </div>
                <div>
                  <span className="text-2xl font-bold text-white block">Wave Spark</span>
                  <span className="text-xs text-ocean-sky/60">Ocean Energy Solutions</span>
                </div>
              </div>

              <p className="text-ocean-sky/70 leading-relaxed mb-6 max-w-xs">
                Transforming ocean waves into clean, sustainable energy. Building a greener future for coastal communities worldwide.
              </p>

              {/* Contact Info */}
              <div className="space-y-3 mb-6">
                <a href="mailto:info@wavespark.com" className="flex items-center gap-3 text-ocean-sky/70 hover:text-wave-yellow transition-colors duration-300">
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  info@wavespark.com
                </a>
                <a href="tel:+1234567890" className="flex items-center gap-3 text-ocean-sky/70 hover:text-wave-yellow transition-colors duration-300">
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  +961 12345678
                </a>
              </div>

              {/* Social Links */}
              <div className="flex flex-wrap gap-3">
                {footerSections.social.map((social) => (
                  <motion.a
                    key={social.id}
                    href={social.href}
                    whileHover={{ scale: 1.1, y: -3 }}
                    whileTap={{ scale: 0.95 }}
                    className="w-11 h-11 rounded-xl bg-ocean-light/10 hover:bg-gradient-to-br hover:from-ocean-light hover:to-ocean-blue border border-ocean-light/20 hover:border-ocean-light/40 flex items-center justify-center transition-all duration-300 group"
                    aria-label={social.name}
                  >
                    <svg
                      className="w-5 h-5 text-ocean-sky group-hover:text-white transition-colors duration-300"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      {social.icon}
                    </svg>
                  </motion.a>
                ))}
              </div>
            </motion.div>

            {/* Company Links */}
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUpVariants}
              transition={{ delay: 0.1 }}
            >
              <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-6 flex items-center gap-2">
                <span className="w-8 h-0.5 bg-wave-yellow"></span>
                Company
              </h4>
              <ul className="space-y-3">
                {footerSections.company.map((link) => (
                  <li key={link.id}>
                    <a
                      href={link.href}
                      className="text-ocean-sky/70 hover:text-wave-yellow hover:translate-x-1 inline-block transition-all duration-300 text-sm"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* Solutions Links */}
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUpVariants}
              transition={{ delay: 0.2 }}
            >
              <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-6 flex items-center gap-2">
                <span className="w-8 h-0.5 bg-wave-yellow"></span>
                Solutions
              </h4>
              <ul className="space-y-3">
                {footerSections.solutions.map((link) => (
                  <li key={link.id}>
                    <a
                      href={link.href}
                      className="text-ocean-sky/70 hover:text-wave-yellow hover:translate-x-1 inline-block transition-all duration-300 text-sm"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* Support Links */}
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUpVariants}
              transition={{ delay: 0.3 }}
            >
              <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-6 flex items-center gap-2">
                <span className="w-8 h-0.5 bg-wave-yellow"></span>
                Support
              </h4>
              <ul className="space-y-3">
                {footerSections.support.map((link) => (
                  <li key={link.id}>
                    <a
                      href={link.href}
                      className="text-ocean-sky/70 hover:text-wave-yellow hover:translate-x-1 inline-block transition-all duration-300 text-sm"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* Legal Links */}
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUpVariants}
              transition={{ delay: 0.4 }}
            >
              <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-6 flex items-center gap-2">
                <span className="w-8 h-0.5 bg-wave-yellow"></span>
                Legal
              </h4>
              <ul className="space-y-3">
                {footerSections.legal.map((link) => (
                  <li key={link.id}>
                    <a
                      href={link.href}
                      className="text-ocean-sky/70 hover:text-wave-yellow hover:translate-x-1 inline-block transition-all duration-300 text-sm"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </motion.div>
          </div>
        </div>

        {/* Bottom Bar */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUpVariants}
          className="border-t border-ocean-light/10 py-8"
        >
          <div className="flex flex-col lg:flex-row justify-between items-center gap-6">
            <div className="flex flex-col sm:flex-row items-center gap-4 text-ocean-sky/60 text-sm">
              <p className="text-center sm:text-left">
                © {currentYear} Wave Spark. All rights reserved.
              </p>
              <span className="hidden sm:inline text-ocean-light/20">•</span>
              <div className="flex items-center gap-2">
                <svg className="w-5 h-5 text-ocean-light" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10 12a2 2 0 100-4 2 2 0 000 4z"/>
                  <path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd"/>
                </svg>
                <span>Supporting UN SDG 14: Life Below Water</span>
              </div>
            </div>

            {/* Certifications/Badges */}
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2 px-4 py-2 bg-ocean-light/5 rounded-lg border border-ocean-light/10">
                <svg className="w-5 h-5 text-green-400" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                </svg>
                <span className="text-xs text-ocean-sky/70 font-medium">ISO Certified</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-ocean-light/5 rounded-lg border border-ocean-light/10">
                <svg className="w-5 h-5 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                </svg>
                <span className="text-xs text-ocean-sky/70 font-medium">Carbon Neutral</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Decorative Bottom Wave */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-wave-yellow to-transparent" />
    </footer>
  );
}
